import type { ChallengePhaseWithCountDto } from '@@types/api.types';
import { BadgeList } from '@components/shared/badge-list.component';
import { useCriteriaLabels } from '@hooks/use-criteria-labels.hook';
import type { FC } from 'react';

type ChallengePhaseCardProps = {
  matchCount: number;
  phase: ChallengePhaseWithCountDto;
  position: number;
};

export const ChallengePhaseCard: FC<ChallengePhaseCardProps> = (props) => {
  const { matchCount, phase, position } = props;
  const { formatCriteriaLabel } = useCriteriaLabels();

  const criteriaBadges =
    phase.criteria?.map((criterion) => ({
      id: criterion.id,
      name: formatCriteriaLabel(criterion),
    })) ?? [];

  return (
    <div className="bg-white border space-y-3 border-gray-200 rounded-lg shadow-sm p-4">
      <div className="flex gap-2 items-center">
        <div className="px-1.5 min-w-7 flex items-center justify-center text-lg font-semibold text-[#3D2EFF] bg-[#3D2EFF1A] rounded-sm">
          {matchCount}
        </div>
        <div className="flex flex-col gap-0">
          <h3 className="text-sm font-medium text-gray-800">
            Phase {position}: {phase.name}
          </h3>
        </div>
      </div>

      <div className="space-y-4">
        {criteriaBadges.length > 0 && (
          <div className="space-y-2">
            <BadgeList
              items={criteriaBadges}
              badgeClassName="text-left"
              limit={4}
              size="sm"
            />
          </div>
        )}
      </div>
    </div>
  );
};
